import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import { colors } from "constants/tailwind";

const ResponsiveTooltip = () => {
  return (
    <Tooltip
      id="tooltip"
      place="top"
      opacity={1}
      style={{
        backgroundColor: colors.indigo[500],
        color: "#fff",
        zIndex: 100,
      }}
    />
  );
};

export default ResponsiveTooltip;
